import React, { useState } from 'react';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import * as styles from './LegalDialog.css.ts';
import termsContentEn from '../../../../TERMS_OF_SERVICE.md?raw';
import termsContentJa from '../../../../TERMS_OF_SERVICE_JA.md?raw';

interface TermsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TermsDialog: React.FC<TermsDialogProps> = ({ isOpen, onClose }) => {
  const [language, setLanguage] = useState<'en' | 'ja'>('en');

  const content = language === 'en' ? termsContentEn : termsContentJa;
  const title = language === 'en' ? 'Terms of Service' : '利用規約';

  const footer = (
    <Button variant="primary" onClick={onClose}>
      Close
    </Button>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="lg"
      footer={footer}
    >
      <div className={styles.languageToggle}>
        <button
          className={language === 'en' ? styles.languageButtonActive : styles.languageButton}
          onClick={() => setLanguage('en')}
        >
          English
        </button>
        <button
          className={language === 'ja' ? styles.languageButtonActive : styles.languageButton}
          onClick={() => setLanguage('ja')}
        >
          日本語
        </button>
      </div>
      <div className={styles.legalContent}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </Dialog>
  );
};
